(function ($) {
// toggle preview blocks visibility (show/hide)
    var toggle_visibility = function ($el, val, model, options) {
        $el.toggle(!!+val);
    };

    var photo_settings = function ($el, val, model, options) {
        var layout = model.get('layout');
        var $custom_width = $('.photo_width');
        var $top_margin = $('.photo_top_margin');
        var photo_sizes = {
            'a-full': '100%'
        };

        toggle_visibility($el, val[0], model, options); // is block visible?
        var $wrapper = $el.find('.photo-wrapper');
        var $shape = $el.find('.photo-shape');
        var $photo = $el.find('.photo-container');

        $custom_width.hide();

        AwesomeUtil.removeClass($shape, 'aet-shape-');
        AwesomeUtil.removeClass($wrapper, 'aet-shape-');
        $shape.addClass('aet-shape-' + val[1]);
        $wrapper.addClass('aet-shape-' + val[1]);

        var css = '#group-preview .aet-effect-nova li[testimonial-id]:hover .photo-shape:after{border-color: ' + val[6] + ';}';

        if (val[2] == 'a-full') {
            $el.css('margin-top', '0');
            $shape.css('width', photo_sizes[val[2]]);
            $photo.css('width', photo_sizes[val[2]]);
            $photo.css('padding-bottom', photo_sizes[val[2]]);
            $top_margin.hide();
        }
        if (val[2] == 'custom') {
            $el.css('margin-top', AwesomeUtil.calc_size(val[4]));
            $shape.css('width', AwesomeUtil.calc_size(val[3]));
            $custom_width.show();
            $top_margin.show();
        }
        if(layout == 'grid_float' || layout == 'widget'){
            $el.css('width', AwesomeUtil.calc_size(val[3]));
            $el.css('padding-top', AwesomeUtil.calc_size(val[4]));
        }
        if (layout == 'single') {
            $el.css('margin-top', AwesomeUtil.calc_size(val[4]));
        }
        if (layout == 'single_showcase') {
            css += '#group-preview li.active .single_showcase-container .photo-shape:after{border-color:' + val[5] + ' !important;}';
            css += '#group-preview li.active:hover .single_showcase-container .photo-shape:after{border-color:' + val[6] + ' !important;}';

            $('.clone', aet_panel).remove();
            if($('.clone', aet_panel).length === 0){
                var $clone_before = $shape.clone().addClass('clone clone-before').removeClass('photo-shape');
                var $clone_after = $shape.clone().addClass('clone clone-after').removeClass('photo-shape');
                $shape.before($clone_before);
                $shape.after($clone_after);
            }
            $el.css('margin-top', AwesomeUtil.calc_size(val[4]));
        }
        if(layout == 'single_showcase' || layout == 'grid_float' || layout == 'widget'){
            if (val[2] == 'a-full') {
                $el.css('width', photo_sizes[val[2]]);
            }
            if (val[2] == 'custom') {
                $el.css('width', AwesomeUtil.calc_size(val[3]));
            }
        }

        $('#aet-photo-border-css', $el).remove();
        $el.append('<style id="aet-photo-border-css" type="text/css">' +
            css +
        '</style>');
    };

    var icons_settings = function ($el, val, model, options) {
        toggle_visibility($el, val[0], model, options);
        $el.css('color', val[1]);
        $el.css('color', val[1]);
        $el.css('margin-top', AwesomeUtil.calc_size(val[3]));
        $el.css('text-align', val[4]);

        $el.css('font-size', 'initial');
        var width = $el.outerWidth();
        var icon_max_size = (width / 6) - 5;
        $el.css('font-size', AwesomeUtil.clean_number(val[2]) > icon_max_size ? icon_max_size : val[2]);
    }

// handle preview block appearance on tooltip editor settings change
    var font_settings = function ($el, val, model, options) {
        var color_field = options.selector.replace_all('.testimonial_', '') + '_color';
        toggle_visibility($el, val[0], model, options); // is block visible?
        var $elc = $el.find('.group-field-content');
        //reset styles
        $elc.css('font-weight', 'normal');
        $elc.css('font-style', 'normal');
        $el.find('.font-style .btn').removeClass('active'); // reset font-style buttons

        $elc.css('font-size', val[1]); // font size
        $elc.css('color', val[2]); // text color

        if (!!+val[3]) {
            $el.find('[data-option-name="bold"]').addClass('active'); // set button "bold" to active state
            $elc.css('font-weight', 'bold');
        }
        if (!!+val[4]) {
            $el.find('[data-option-name="italic"]').addClass('active'); // set button "italic" to active state
            $elc.css('font-style', 'italic');
        }
        $elc.css('text-transform', val[5]); // is uppercase
        $elc.css('text-align', val[6]); //text align
        $el.css('margin-top', AwesomeUtil.calc_size(val[7])); //margin-top
    };

    var card_body_settings = function ($el, color, border, shadow) {
        $el.css('background-color', color);
        $el.css('border', '1px solid ' + border);
        if (shadow !== '') {
            $el.css('-webkit-box-shadow', '0 0 5px 0 ' + shadow);
            $el.css('-moz-box-shadow', '0 0 5px 0 ' + shadow);
            $el.css('box-shadow', '0 0 5px 0 ' + shadow);
        }
    };

    var rating_icon_settings = function ($el, val, model, options) {
        // bar size & color
        var width = 'width:' + val[0] + ';';
        var height = 'height:' + val[0] + ';';
        var count = parseInt(val[5]);
        var color, icon, html;

        var raw = val[0].replace(/\D+/g, '');
        var full = raw * count;
        $el.find('.skill-value').css('width', AwesomeUtil.calc_size(full + ''));
        $el.find('.rating-fill').css('width', AwesomeUtil.calc_size(full * 0.8 + ''));

        // type
        if(val[2] == 'replace'){
            color = 'background-color:' + val[1] + ';';
            icon = val[2];
            var webkit_mask = '-webkit-mask-image: url(\'' + val[3] + '\');';
            var mask = 'mask-image: url(\'' + val[3] + '\');';
            html = window.templates.rating.image({
                width: width,
                height: height,
                color: color,
                webkit_mask: webkit_mask,
                mask: mask
            });
            $el.find('.rating-background').html('');
            $el.find('.rating-fill').html('');
            for(var i = 0; i < count; i++){
                $el.find('.rating-background').append(html);
                $el.find('.rating-fill').append(html);

            }
        }else{
            color = 'color:' + val[1] + ';';
            icon = val[2];
            $el.find('.icon').css('color', val[1]);
            html = window.templates.rating.svg({
                width: width,
                height: height,
                color: color,
                icon: icon
            });
            $el.find('.rating-background').html('');
            $el.find('.rating-fill').html('');
            for(var j = 0; j < count; j++){
                $el.find('.rating-background').append(html);
                $el.find('.rating-fill').append(html);

            }
        }
        $el.find('> div').hide();
        $el.find('.rating-format-5s').show();
        $el.attr('class', 'group-field-content icon-count-' + val[5]);

        $el.find('.skill-value').css('max-width', '100%');
        var fill_max_width = $el.find('.rating-background').outerWidth();
        fill_max_width = Math.round(fill_max_width / 10) * 10;

        $el.find('.skill-value').css('max-width', fill_max_width);
        $el.find('.rating-fill').css('max-width', fill_max_width * 0.8);

        var icon_max_width = $el.find('.rating-background > *').outerWidth();

        $el.find('.rating-background > *').each(function (index, item) {
            $(item).css('max-height', icon_max_width);
        });
        $el.find('.rating-fill > *').each(function (index, item) {
            $(item).css('max-width', icon_max_width);
            $(item).css('max-height', icon_max_width);
        });
    };

    var short_text_settings = function ($el, val, model, options) {
        var model_field = 'styles.' + model.get('layout') + '.';
        var $parent = $el.parent();
        var short_text_position = parseInt(AwesomeUtil.find_index_by_value('short_text', val[8]));
        var photo_position = parseInt(AwesomeUtil.find_index_by_value('photo', val[8]));
        var parent_class = $parent.attr('class').split(' ');
        var nubbin_class, nubbin_position, nubbin_width_offset;
        var background_color = val[5];
        var border_color = val[2];
        var border_width = AwesomeUtil.clean_number(val[1]);
        parent_class = parent_class.filter(function (item) {
            return item.indexOf('nubbin') !== 0;
        });
        parent_class = parent_class.join(' ');

        if(model.get('layout') == 'grid' ||
            model.get('layout') == 'single'){
            nubbin_width_offset = AwesomeUtil.clean_number(val[1]) > 1 ? AwesomeUtil.clean_number(val[1]) : 0;
            nubbin_position = short_text_position < photo_position ? 'bottom' : 'top';
            if (!!+val[7]) {
                nubbin_class = 'nubbin-' + nubbin_position;
            }else{
                nubbin_class = 'nubbin-none';
            }
        }
        if(model.get('layout') == 'grid_float'||
            model.get('layout') == 'widget'){
            nubbin_width_offset = AwesomeUtil.clean_number(val[1]) > 1 ? AwesomeUtil.clean_number(val[1]) + 2 : 1;
            nubbin_position = short_text_position === 0 ? 'bottom' : 'top';
            var nubbin_offset = AwesomeUtil.clean_number(model.get(model_field + 'photo_width')) / 2;
            var nubbin_align = photo_position === 0 ? 'left' : 'right';
            var nubbin_margin = 'margin-' + nubbin_align;
            if (!!+val[7]) {
                nubbin_class = 'nubbin-' + nubbin_position + '-' + nubbin_align;
            }else{
                nubbin_class = 'nubbin-none';
            }
            $parent.find('.nubbin-' + nubbin_position).css('margin-right', 'auto');
            $parent.find('.nubbin-' + nubbin_position).css('margin-left', 'auto');
            $parent.find('.nubbin-' + nubbin_position).css(nubbin_margin, AwesomeUtil.calc_size(nubbin_offset));
        }
        if(model.get('layout') == 'single_showcase'){
            nubbin_width_offset = AwesomeUtil.clean_number(val[1]) > 1 ? AwesomeUtil.clean_number(val[1]) : 0;
            nubbin_position = short_text_position === 0 ? 'bottom' : 'top';
            if (!!+val[7]) {
                nubbin_class = 'nubbin-' + nubbin_position;
            }else{
                nubbin_class = 'nubbin-none';
            }
        }

        $el.css('padding', AwesomeUtil.calc_size(val[0]));
        $parent.css('margin-top', 'auto').css('margin-bottom', 'auto');
        $parent.css('margin-' + nubbin_position, AwesomeUtil.calc_size(val[9]));

        if (!!+val[6]) {
            $el.css('border-width', AwesomeUtil.calc_size(border_width));
            $el.css('border-color', border_color);
            $el.css('border-radius', AwesomeUtil.calc_size(val[3]));
            $el.css('background-color', background_color);
            $parent.attr('class', parent_class + ' ' + nubbin_class);
            $parent.removeClass('body_off');
        } else {
            $parent.addClass('body_off');
        }

        var offset_key = nubbin_position == 'bottom' ? 'top' : 'bottom';
        var offset_value = nubbin_position == 'bottom' ? -13-nubbin_width_offset : -1-nubbin_width_offset;

        $parent.find('.nubbin-' + nubbin_position + ' span')
            .css('top', 'auto')
            .css('bottom', 'auto')
            .css(offset_key, offset_value);

        if(border_width === 0){
            border_color = background_color;
        }

        $parent.find('.nubbin-' + nubbin_position).css('border-' + offset_key + '-color', border_color);
        $parent.find('.nubbin-' + nubbin_position + ' span').css('border-' + offset_key + '-color', background_color);
    };

// Backbone View for group preview
    GroupPreview = Backbone.View.extend({
        initialize: function (options) {
            _.bindAll(this, 'before_render', 'render', 'after_render'); // create callbacks for 'before_render' and 'after_render' pseudo events
            var _this = this;
            this.render = _.wrap(this.render, function (render) {
                _this.before_render();
                render();
                _this.after_render();
                return _this;
            });
        },

        // data bindings
        bindings: function () {
            var result = {};
            var layout = model.get('layout');
            var model_field = 'styles.' + layout + '.';

            // group base gaps and background color
            result['#group-preview .aet-layout'] = {
                observe: [
                    model_field + 'hover',
                    model_field + 'bounce'
                ],
                update: function ($el, val, model, options) {
                    AwesomeUtil.removeClass($el, 'aet-effect-');
                    $el.removeClass('aet-bounce');
                    if (val[0] != 'off') {
                        $el.addClass('aet-effect-' + val[0]);
                    }
                    if (val[1] == '1') {
                        $el.addClass('aet-bounce');
                    }
                }
            };


            // group base gaps and background color
            result['#group-preview ul.testimonials-box'] = {
                observe: [
                    model_field + 'gaps',
                    model_field + 'base_color',
                    model_field + 'align'
                ],
                update: function ($el, val, model, options) {
                    $el.css('text-align', 'center');
                    if (model.get('layout') == 'grid' || model.get('layout') == 'grid_float') {
                        $el.css('background-color', val[1]);
                        $el.css('text-align', val[2]);
                    }
                }
            };

            // group card base color, border color, shadow color and gaps
            result['#group-preview ul.testimonials-box > li'] = {
                observe: [
                    model_field + 'card_margin'
                ],
                update: function ($el, val, model, options) {
                    //$el.css('padding', val);
                }
            };

            // group card base color, border color, shadow color and gaps
            result['#group-preview ul.testimonials-box > li > div'] = {
                observe: [
                    model_field + 'card_base_color',
                    model_field + 'card_border_color',
                    model_field + 'card_shadow_color',
                    model_field + 'card_gaps',
                    model_field + 'body_visible'
                ],
                update: function ($el, val, model, options) {
                    $el.css('padding', '10');
                    if (model.get('layout') == 'grid' || model.get('layout') == 'grid_float' || model.get('layout') == 'widget') {
                        if (!!+val[4]) {
                            card_body_settings($el, val[0], val[1], val[2]); // set card body bg, border and shadow
                        } else {
                            $el.css('background-color', 'transparent');
                            $el.css('border-color', 'transparent');
                            $el.css('-webkit-box-shadow', 'none');
                            $el.css('-moz-box-shadow', 'none');
                            $el.css('box-shadow', 'none');
                        }
                        if (model.get(model_field + 'photo_size') == 'a-full') {
                            $el.css('padding', '0');
                        }
                    } else {
                        $el.css('border-top-color', val[1]);
                        $el.css('border-bottom-color', val[1]);
                    }
                    if (model.get('layout') == 'single_showcase'){
                        $el.css('padding', 0);
                        $('.aet-layout', aet_panel).css('padding', '10');
                    }
                }
            };

            // divider
            result['.testimonial_divider, .testimonials-divider'] = {
                observe: [
                    model_field + 'divider_visible',
                    model_field + 'divider_color',
                    model_field + 'divider_width',
                    model_field + 'divider_top_margin',
                ],
                update: function ($el, val, model, options) {
                    toggle_visibility($el, val[0], model, options); // divider visible
                    $el.find('span').css('background-color', val[1]); // divider color
                    $el.find('span').css('width', AwesomeUtil.calc_size(val[2])); // divider width
                    $el.css('margin-top', AwesomeUtil.calc_size(val[3])); // divider top margin

                }
            };

            // group layout slider
            result['.card_margin'] = {
                observe: model_field + 'slider',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if (val === 0 &&
                        model.get('layout') == 'grid' ||
                        model.get('layout') == 'grid_float') {
                        $el.show();
                    }
                }
            };

            // group layout align
            result['.group-align'] = {
                observe: model_field + 'align',
                update: function ($el, val, model, options) {
                    $el.find('.btn').removeClass('active');
                    $el.find('.align-' + val).addClass('active');
                }
            };

            // testimonial photo block settings
            result['.testimonial_photo'] = {
                observe: [
                    model_field + 'photo_visible', // 0
                    model_field + 'photo_shape', // 1
                    model_field + 'photo_size', // 2
                    model_field + 'photo_width', // 3
                    model_field + 'photo_top_margin', // 4
                    model_field + 'button_color', // 5
                    model_field + 'button_hover_color', // 6
                ],
                update: photo_settings
            };

            // testimonial name block bindings
            result['.testimonial_name'] = {
                observe: [
                    model_field + 'name_visible',
                    model_field + 'name_font_size',
                    model_field + 'name_color',
                    model_field + 'name_bold',
                    model_field + 'name_italic',
                    model_field + 'name_text_transform',
                    model_field + 'name_align',
                    model_field + 'name_top_margin'
                ],
                update: font_settings
            };

            // testimonial position block bindings
            result['.testimonial_position, .testimonials-position'] = {
                observe: [
                    model_field + 'position_visible',
                    model_field + 'position_font_size',
                    model_field + 'position_color',
                    model_field + 'position_bold',
                    model_field + 'position_italic',
                    model_field + 'position_text_transform',
                    model_field + 'position_align',
                    model_field + 'position_top_margin'
                ],
                update: font_settings
            };

            // testimonial short bio block bindings
            result['.testimonial_short_text, .testimonials-short_text'] = {
                observe: [
                    model_field + 'short_text_visible',
                    model_field + 'short_text_font_size',
                    model_field + 'short_text_color',
                    model_field + 'short_text_bold',
                    model_field + 'short_text_italic',
                    model_field + 'short_text_text_transform',
                    model_field + 'short_text_align',
                    0
                ],
                update: font_settings
            };

            result['.testimonial_short_text .group-field-content'] = {
                observe: [
                    model_field + 'short_text_padding', //0
                    model_field + 'short_text_border_width', //1
                    model_field + 'short_text_border_color', //2
                    model_field + 'short_text_border_radius', //3
                    model_field + 'short_text_border_nubbin', //4
                    model_field + 'short_text_background_color', //5
                    model_field + 'short_text_body_visible',//6
                    model_field + 'short_text_nubbin_visible', //7
                    model_field + 'blocks_order', //8
                    model_field + 'short_text_margin' //9
                ],
                update: short_text_settings
            };

            // testimonial phone block settings
            result['.testimonial_phone'] = {
                observe: [
                    model_field + 'phone_visible',
                    model_field + 'contacts_font_size',
                    model_field + 'contacts_color',
                    model_field + 'contacts_bold',
                    model_field + 'contacts_italic',
                    model_field + 'contacts_text_transform',
                    model_field + 'contacts_align',
                    model_field + 'contacts_top_margin'
                ],
                update: font_settings
            };
            // testimonial phone block settings
            result['.testimonial_email'] = {
                observe: [
                    model_field + 'email_visible',
                    model_field + 'contacts_font_size',
                    model_field + 'contacts_color',
                    model_field + 'contacts_bold',
                    model_field + 'contacts_italic',
                    model_field + 'contacts_text_transform',
                    model_field + 'contacts_align',
                    model_field + 'contacts_top_margin'
                ],
                update: font_settings
            };
            // testimonial social block settings
            result['.testimonial_skype'] = {
                observe: [
                    model_field + 'skype_visible',
                    model_field + 'contacts_font_size',
                    model_field + 'contacts_color',
                    model_field + 'contacts_bold',
                    model_field + 'contacts_italic',
                    model_field + 'contacts_text_transform',
                    model_field + 'contacts_align',
                    model_field + 'contacts_top_margin'
                ],
                update: font_settings
            };
            // testimonial social block settings
            result['.testimonial_website'] = {
                observe: [
                    model_field + 'website_visible',
                    model_field + 'contacts_font_size',
                    model_field + 'contacts_color',
                    model_field + 'contacts_bold',
                    model_field + 'contacts_italic',
                    model_field + 'contacts_text_transform',
                    model_field + 'contacts_align',
                    model_field + 'contacts_top_margin'
                ],
                update: font_settings
            };
            // testimonial social block settings
            result['.testimonial_location'] = {
                observe: [
                    model_field + 'location_visible',
                    model_field + 'contacts_font_size',
                    model_field + 'contacts_color',
                    model_field + 'contacts_bold',
                    model_field + 'contacts_italic',
                    model_field + 'contacts_text_transform',
                    model_field + 'contacts_align',
                    model_field + 'contacts_top_margin'
                ],
                update: font_settings
            };

            // testimonial social block settings
            result['.testimonial_social, .testimonials-social'] = {
                observe: [
                    model_field + 'social_visible',
                    model_field + 'social_color',
                    model_field + 'social_size',
                    model_field + 'social_top_margin',
                    model_field + 'social_align'
                ],
                update: icons_settings
            };

            // testimonial social block settings
            result['.testimonial_contacts, .testimonials-contacts'] = {
                observe: [
                    model_field + 'contacts_visible',
                    model_field + 'contacts_color',
                    model_field + 'contacts_size',
                    model_field + 'contacts_top_margin',
                    model_field + 'contacts_align'
                ],
                update: icons_settings
            };

            // testimonial social block settings
            result['.testimonial_source, .testimonials-source'] = {
                observe: [
                    model_field + 'source_visible',
                    model_field + 'source_font_size',
                    model_field + 'source_color',
                    model_field + 'source_bold',
                    model_field + 'source_italic',
                    model_field + 'source_text_transform',
                    model_field + 'source_align',
                    model_field + 'source_top_margin'
                ],
                update: font_settings
            };

            // skills block settings
            result['.testimonial_rating, .testimonials-rating'] = {
                observe: [
                    model_field + 'rating_visible',
                    model_field + 'rating_font_size',
                    model_field + 'rating_text_color',
                    model_field + 'rating_bold',
                    model_field + 'rating_italic',
                    model_field + 'rating_text_transform',
                    model_field + 'rating_align',
                    model_field + 'rating_top_margin'
                ],
                update: font_settings
            };
            result['.testimonial_rating .group-field-content'] = {
                observe: [
                    model_field + 'rating_size', // 0
                    model_field + 'rating_bar_color', // 1
                    model_field + 'rating_icon', // 2
                    model_field + 'rating_source', // 3
                    model_field + 'rating_scale', // 4
                    model_field + 'rating_icon_count', // 5
                    model_field + 'rating_visible', // 6
                ],
                update: rating_icon_settings
            };
            // form submit selector
            result['[name="group_form_submit_selector"]'] = {
                observe: 'form.submit_selector',
                update: function($el, val, model, options) {
                    var update = function () {
                        if ($el.val() == '') {
                            var id = model.get('id'),
                                def = '.aet_submission_form_trigger_' + id;
                            $el.val(def)
                            model.set('form.submit_selector', def);
                        }
                    }
                    update();
                    $($el).on('blur', update);
                }
            }

            return result;
        },
        // before render callback
        /* jshint multistr:true */
        before_render: function () {
            var button = '<button data-action="call-tooltip">\
            <svg class="icon" viewBox="0 0 28 28">\
            <use xlink:href="#icon-pen"></use>\
            </svg>\
            </button>';
            this.$el.find('#group-preview .grid-container').append(button);

        },
        render: function () {
            this.stickit();
            return this;
        },
        // after render callback
        after_render: function () {
            /*var sizes = ['full', 'large', 'medium', 'thumbnail'];
             var a_ajax = new AwesomeAjax();
             var $parent = jQuery('#a-slide-panel .testimonial_photo');
             var id = $parent.parents('li').attr('testimonial-id');

             jQuery.each(sizes, function (index, value) {
             //a_ajax.get_group_preview_photo($parent, id, value);
             })*/
        },
        close: function () {
            this.unstickit();
        }
    });
})(jQuery);